/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Batch_Complete_TitleInputs */



/**
* | output |
* | --- |
* | "Batch export complete" |
*
* @param {Explorer_Info_Batch_Complete_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_batch_complete_title = /** @type {((inputs?: Explorer_Info_Batch_Complete_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Batch_Complete_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exportation par lots terminée")
	if (locale === "de") return /** @type {LocalizedString} */ ("Stapelexport abgeschlossen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esportazione batch completata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт партии завершен.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportación por lotes completada")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("批量导出完成")
	if (locale === "ja") return /** @type {LocalizedString} */ ("バッチエクスポート完了")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बैच निर्यात पूर्ण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportação em lote concluída")
	return /** @type {LocalizedString} */ ("Batch export complete")
});